class MFRStackCards {
  constructor(i, e) {
    this.$index = i;
    this.$element = $(e);

    this.selectors = {
      card: ".stacking-cards__card",
      head: ".stacking-cards__card-head",
      body: ".stacking-cards__card-body",
    };

    this.init();
  }

  init() {
    this.$card = this.$element.find(this.selectors.card);
    this.$wrapper = this.$element;

    if (Shopify.designMode) return; 
    this.initStickyCards();
  }

  initStickyCards() {
    if (ScrollTrigger && ScrollTrigger.create) {
      const totalHeight = this.getCardTotalHeight();

      this.$card.each((i, e) => {
        gsap.set(e, {
          zIndex: i + 1,
        });

        // if( i == this.$card.length - 1 ) return;
        ScrollTrigger.create({
          trigger: e,
          start: this.getStartTrigger(totalHeight, i),
          pin: true,
          pinSpacing: false,
          pinType: "fixed",
          // pinType: ScrollTrigger.isTouch ? "fixed" : "transform",
          anticipatePin: 1,
          // markers: true,
          end: this.getEndTrigger($(e)),
          //   invalidateOnRefresh: true,
        });
      });
    }
  }

  getPreviousCardsHeight(index) {
    const card = $(this.$card[index - 1]);

    if (!card.length) return 0;
    let totalHeight = 0;
    this.$card.each((i, e) => {
      const borderRadius = parseFloat(
        $(e).css("border-radius").replace("px", "")
      );
      const cardTitleHeight =
        $(e).find(this.selectors.head + ':visible').length ? $(e).find(this.selectors.head).outerHeight() - borderRadius : 0;

      if ($(e).data("index") == index) return false;

      totalHeight += parseInt(cardTitleHeight);
    });

    return totalHeight;
  }

  getCardTotalHeight() {
    let totalHeight = 0;
    this.$card.each((i, e) => {
      const card = $(e);

      if (i == this.$card.length - 1) {
        totalHeight += card.innerHeight();
        return;
      } else {
        const cardTitleHeight = this.getCardTitleHeight(card);

        totalHeight += cardTitleHeight;
      }
    });

    return totalHeight;
  }

  getStartTrigger(cardHeight, index) {
    const headerHeight = $("header.header").height();
    const viewportHeight = $(window).outerHeight();
    const spacing = (viewportHeight - headerHeight - cardHeight) / 2;
    const startPosition = headerHeight + spacing;
    const borderRadius = parseFloat(
      $(this.$card.get(index)).css("border-radius")
    );
    
    if( $( window ).height() <= 639 ) {
      return `top +=${$( "header.header" ).height() + 30 }px`;
    }
    else {
      return `top +=${startPosition + this.getPreviousCardsHeight(index) - 20}px`;
    }
  }

  getEndTrigger(card) {
    const cardWrapperHeight = this.$wrapper.outerHeight();
    const cardHeight = card.outerHeight();
    const cardPositionTop = card.position().top;
    const cardPositionHeight = this.getCardPositionHeight(card);
    const offset =
      cardWrapperHeight - cardHeight - cardPositionTop - cardPositionHeight - this.getPreviousBorderRadius();
    
    return `+=${offset}px`;
  }

  getPreviousBorderRadius() {
    let borderRadius = 0;

    this.$card.each( ( i, e ) => {
      if( this.$card.length - 1 == i ) return false;

      borderRadius += parseFloat( $( e ).css( "border-radius" ).replace( "px", "" ) );
    } );

    return borderRadius;
  }

  getCardPositionHeight(card) {
    let cardPositionHeight = card.outerHeight(true);
    let cardsHeight = this.getCardTotalHeight();

    this.$card.each((i, e) => {
      if ($(e).data("index") == card.data("index")) {
        return false;
      }
      cardPositionHeight += this.getCardTitleHeight($(e));
    });

    return cardsHeight - cardPositionHeight;
  }

  getCardTitleHeight(card) {
    const borderRadius = parseFloat(
      card.css("border-radius").replace("px", "")
    );
    const cardTitleHeight = card.find(this.selectors.head).innerHeight();

    return parseFloat(cardTitleHeight) - borderRadius;
  }
}
